// Storefront presentation only. Shopify remains the authority for prices, variants and carts.
(() => {
  const storageKey = 'fivepoint:saved-fabrics:v1';
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const hoverNavigation = matchMedia('(min-width:900px) and (hover:hover)');
  let saved = [];
  let storageError = '';
  try {
    const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(value)) throw new Error('Saved fabric list is invalid');
    saved = value.filter(item => typeof item?.url === 'string' && /^\/products\/[a-z0-9-]+$/.test(item.url) && typeof item.title === 'string').slice(0, 200);
  } catch (error) { storageError = 'Saved fabrics could not be read in this browser. Please allow site storage and reload.'; }
  const savedDialog = () => document.querySelector('[data-fp-saved-dialog]');
  let savedRefresh;
  async function renderSaved(refresh = false) {
    savedRefresh?.abort();
    document.querySelectorAll('[data-fp-wishlist-count]').forEach(node => { node.textContent = String(saved.length); });
    document.querySelectorAll('[data-fp-save]').forEach(button => { button.setAttribute('aria-pressed', String(saved.some(item => item.url === button.dataset.url))); });
    const list = document.querySelector('[data-fp-saved-list]');
    if (!list) return;
    list.replaceChildren();
    list.removeAttribute('aria-busy');
    if (storageError || !saved.length) {
      const message = document.createElement('p');
      message.textContent = storageError || 'Save fabrics with the heart on a product card. Your selection will appear here.';
      if (storageError) message.setAttribute('role', 'alert');
      list.append(message); return;
    }
    let visible = saved;
    if (document.querySelector('[data-dss-market-context]')?.dataset.enabled === 'true') {
      if (!refresh) return;
      const controller = new AbortController(); savedRefresh = controller;
      list.setAttribute('aria-busy', 'true'); list.textContent = 'Loading current fabric details…';
      try { visible = await window.DSSMarketPresentation.resolve(saved, controller.signal); }
      catch {
        if (controller.signal.aborted) return;
        list.replaceChildren();
        const message = document.createElement('p'); message.setAttribute('role', 'alert'); message.textContent = 'Fabric details could not be refreshed.';
        const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Retry'; retry.addEventListener('click', () => renderSaved(true));
        list.append(message, retry); list.removeAttribute('aria-busy'); return;
      }
      if (controller.signal.aborted) return;
      list.replaceChildren(); list.removeAttribute('aria-busy');
    }
    visible.forEach(item => {
      const row = document.createElement('div'); row.className = 'fp-saved-item';
      const image = document.createElement('img'); image.alt = item.title; image.loading = 'lazy';
      if (typeof item.image === 'string' && /^(https:)?\/\//.test(item.image)) image.src = item.image;
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.dataset.fpRemoveSaved = item.url; remove.setAttribute('aria-label', `Remove ${item.title}`);
      row.append(image, link, remove); list.append(row);
    });
  }
  function save(next, action) {
    if (storageError) { renderSaved(); savedDialog()?.showModal(); return; }
    const changed = Math.abs(next.length - saved.length);
    try {
      localStorage.setItem(storageKey, JSON.stringify(next)); saved = next;
      if (changed) window.FivePointEvents?.emit('fp_saved_change', {action,storage:'local',item_count:changed}, {component_id:'local-saved'});
    }
    catch (error) { storageError = 'Your selection could not be saved. Please allow site storage and try again.'; }
    renderSaved(Boolean(savedDialog()?.open));
    if (storageError) savedDialog()?.showModal();
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button');
    if (!target) return;
    if (target.matches('.fp-mega-trigger,.fp-desktop-menu')) {
      const panel = document.getElementById(target.getAttribute('aria-controls'));
      // A mouse click must not immediately close a menu that mouseenter opened.
      const hoverClick = hoverNavigation.matches && event.detail > 0 && event.pointerType !== 'touch';
      const shouldOpen = hoverClick || panel.hidden;
      closeMega();
      panel.hidden = !shouldOpen;
      target.setAttribute('aria-expanded', String(!panel.hidden));
    }
    if (target.matches('[data-fp-menu-open]')) {
      const dialog = document.getElementById(target.getAttribute('aria-controls'));
      dialog.showModal(); target.setAttribute('aria-expanded', 'true');
      dialog.addEventListener('close', () => { target.setAttribute('aria-expanded', 'false'); target.focus(); }, { once: true });
    }
    if (target.matches('[data-fp-dialog-close]')) target.closest('dialog').close();
    if (target.matches('[data-fp-wishlist-open]')) { renderSaved(true); savedDialog()?.showModal(); }
    if (target.matches('[data-fp-save]')) {
      const { url, title, image } = target.dataset;
      if (saved.some(item => item.url === url)) save(saved.filter(item => item.url !== url), 'remove');
      else if (saved.length < 200) save([...saved, { url, title, image }], 'add');
      else { savedDialog()?.showModal(); }
    }
    if (target.matches('[data-fp-remove-saved]')) save(saved.filter(item => item.url !== target.dataset.fpRemoveSaved), 'remove');
    if (target.matches('[data-fp-estimator-open]')) document.querySelector('[data-fp-estimator]')?.showModal();
  });
  function activateTabGroup(group, tab) {
    group.querySelectorAll('[data-fp-tab]').forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    group.querySelectorAll('[data-fp-panel]').forEach(panel => { panel.hidden = panel.dataset.fpPanel !== tab.dataset.fpTab; });
  }
  function connect(root = document) {
    root.querySelectorAll('.fp-mood-header:not([data-menu-connected])').forEach(header => {
      header.dataset.menuConnected = 'true';
      const navigation = header.querySelector('.fp-mood-nav');
      const hoverRegions = [navigation];
      header.querySelectorAll('.fp-mega-trigger,.fp-desktop-menu').forEach(trigger => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        hoverRegions.push(panel);
        trigger.addEventListener('mouseenter', () => {
          if (!hoverNavigation.matches) return;
          closeMega();
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        });
      });
      // The nav's padding is part of the path from a trigger into its dropdown.
      hoverRegions.forEach(region => region.addEventListener('mouseleave', event => {
        if (!hoverNavigation.matches) return;
        const next = event.relatedTarget;
        if (next instanceof Node && hoverRegions.some(other => other.contains(next))) return;
        closeMega();
      }));
      navigation.querySelectorAll('a').forEach(link => link.addEventListener('mouseenter', () => {
        if (hoverNavigation.matches) closeMega();
      }));
      header.addEventListener('focusout', event => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) closeMega();
      });
    });
    root.querySelectorAll('[data-fp-tabs]:not([data-connected]),.fp-mega__panel:not([data-connected])').forEach(group => {
      group.dataset.connected = 'true';
      const tabs = Array.from(group.querySelectorAll('[data-fp-tab]'));
      let hoverTimer;
      const cancelHover = () => clearTimeout(hoverTimer);
      const activate = tab => { cancelHover(); activateTabGroup(group, tab); };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        if (group.matches('.fp-mega__panel')) {
          // Let the pointer cross another row on its way to the open panel.
          tab.addEventListener('mouseenter', () => {
            cancelHover();
            if (hoverNavigation.matches) hoverTimer = setTimeout(() => { if (!group.hidden) activate(tab); }, 120);
          });
          tab.addEventListener('mouseleave', cancelHover);
        }
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
        });
      });
    });
    root.querySelectorAll('[data-fp-carousel]:not([data-connected])').forEach(carousel => {
      carousel.dataset.connected = 'true';
      const track = carousel.querySelector('[data-fp-carousel-track]');
      if (!track) return;
      const prev = carousel.querySelector('[data-fp-carousel-prev]');
      const next = carousel.querySelector('[data-fp-carousel-next]');
      const update = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: reduceMotion.matches ? 'instant' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: reduceMotion.matches ? 'instant' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      const resize = new ResizeObserver(update); resize.observe(track); update();
    });
    root.querySelectorAll('[data-fp-hero]:not([data-connected])').forEach(hero => {
      hero.dataset.connected = 'true';
      const slides = Array.from(hero.querySelectorAll('[data-fp-hero-slide-v2]'));
      if (slides.length < 2) return;
      const dots = Array.from(hero.querySelectorAll('[data-fp-hero-dot]'));
      const pause = hero.querySelector('[data-fp-hero-pause]');
      let current = 0, paused = reduceMotion.matches, visible = true;
      function show(index) { current = index; slides.forEach((slide, i) => { slide.hidden = i !== index; }); dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index))); }
      function syncPause() { pause.setAttribute('aria-pressed', String(paused)); pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); pause.textContent = paused ? '▷' : 'Ⅱ'; }
      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); paused = true; syncPause(); }));
      pause.addEventListener('click', () => { paused = !paused; syncPause(); });
      hero.addEventListener('focusin', () => { paused = true; syncPause(); });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }); observer.observe(hero);
      const timer = setInterval(() => { if (!hero.isConnected) { clearInterval(timer); observer.disconnect(); return; } if (!paused && visible && !document.hidden) show((current + 1) % slides.length); }, 10000);
      syncPause();
    });
    root.querySelectorAll('[data-fp-estimator-form]:not([data-connected])').forEach(form => {
      form.dataset.connected = 'true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const values = new FormData(form);
        const metres = Math.ceil(Number(values.get('length')) * (1 + Number(values.get('allowance')) / 100));
        form.querySelector('[data-fp-estimator-result]').textContent = `Estimated fabric: ${metres} metre${metres === 1 ? '' : 's'}`;
      });
    });
    renderSaved();
  }
  function closeMega(focusTrigger = false) {
    document.querySelectorAll('.fp-mega-trigger[aria-expanded="true"],.fp-desktop-menu[aria-expanded="true"]').forEach(trigger => {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      panel.hidden = true;
      const firstTab = panel.querySelector('[data-fp-tab]');
      if (firstTab) activateTabGroup(panel, firstTab);
      trigger.setAttribute('aria-expanded', 'false');
      if (focusTrigger) trigger.focus();
    });
  }
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMega(true); });
  document.addEventListener('click', event => { if (!event.target.closest('.fp-mega-trigger,.fp-mega__panel,.fp-desktop-menu,.fp-discover-panel')) closeMega(); });
  matchMedia('(min-width:900px)').addEventListener('change', () => closeMega());
  document.addEventListener('shopify:section:load', event => connect(event.target));
  connect();
})();
